import { ReportRequestModel } from './../../models/models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import * as Models from '../../models/models-index';
import { Observable } from 'rxjs';
import { GetDataSetConfigurationResponse } from '../../models/data-set-configuration-models';

@Injectable()
export class ReportsService {
  constructor(
    private http: HttpClient) { }

  getReport(reportRequest: ReportRequestModel, reportType: string): Observable<Models.ReportResponseModel> {
    reportRequest.reportType = reportType;
    return this.http.post<Models.ReportResponseModel>(
      environment.baseApiUri + '/report',
      reportRequest,
      { headers: { 'Content-Type': 'application/json' } });
  }

  getReportView(reportRequest: ReportRequestModel): Observable<Models.ReportViewResponse> {
    return this.http.post<Models.ReportViewResponse>(
      environment.baseV5ApiUri + '/report',
      reportRequest,
      { headers: { 'Content-Type': 'application/json' } });
  }

  getReportFilterNames(reportName: string): Observable<Models.ReportViewFilterConfiguration> {
    return this.http.get<Models.ReportViewFilterConfiguration>(environment.baseV5ApiUri + `/report/filternames?report=${reportName}`);
  }

  getReportFilters(reportName: string, filterNames: string[], cultureCode: string): Observable<Models.ReportViewFilter[]> {
    const useCultureCode = cultureCode.toLowerCase().indexOf('en') > -1 ? 'en-US' : cultureCode;
    const filterNamesString = filterNames.join(',');
    return this.http.get<Models.ReportViewFilter[]>(
      environment.baseV5ApiUri + `/report/filters?report=${reportName}&filterNames=${filterNamesString}&cultureCode=${useCultureCode}`);
  }

  getDataSets(reportRequest: ReportRequestModel): Observable<Models.DataSet[]> {
    return this.http.post<Models.DataSet[]>(
      environment.baseV5ApiUri + '/report/datasets',
      reportRequest,
      { headers: { 'Content-Type': 'application/json' } });
  }

  projectDataSet(queryName: string): Observable<GetDataSetConfigurationResponse> {
    const params = new HttpParams().set('queryName', queryName);
    return this.http.get<GetDataSetConfigurationResponse>(
      environment.baseV5ApiUri + '/report/projectcolumnconfigs',
      { params }
    );
  }

  // All of this could be consolidated into a single config call that returned all of these elements at once.
  // They're parameter-less
  getAppConfig(): Observable<Models.IAppConfig> {
    return this.http.get<Models.IAppConfig>(environment.baseApiUri + '/getAppConfig');
  }
}
